import { formatDescripcion, shouldRenderTicket } from "../../apis/helper/helperApi";

// Reutilizamos la lógica de la función de utilidad anterior
const generarResumenParaCaso = async (caso: any, perfil?: number) => {
  if (perfil === 4) {
    const newLocal = await Promise.all(
      caso.map(
        async (caso: {
          IdTarea: any;
          Alarma: any;
          ticketRedmine: any;
          Ci: any;
          Usuario: any;
          NombreContrato: any;
          descripcion: any;
        }) => {
          const { Alarma, descripcion, ticketRedmine, Ci, NombreContrato } =
            caso;

          const partesResumen = [];

          if (Alarma) {
            partesResumen.push(`Titulo: ${Alarma}`);
          }
                if (descripcion) {
                  const value = formatDescripcion(descripcion);
                  partesResumen.push(`Descripción: ${value}`);
                }
          if (Ci) {
            partesResumen.push(`Ci: ${Ci}`);
          }
          if (NombreContrato) {
            partesResumen.push(`Contrato: ${NombreContrato}`);
          }

          const renderTicketRedmine = shouldRenderTicket(ticketRedmine);
          if (renderTicketRedmine) {
            partesResumen.push(`Ticket Redmine Nro: ${ticketRedmine}`);
          }
          const resumen =
            partesResumen.length > 0
              ? partesResumen.join("\n\n")
              : "No pudimos obtener los datos del caso";

          return { ...caso, resumen };
        },
      ),
    );

    return newLocal;
  }
  const newLocal = await Promise.all(
    caso.map(
      async (caso: {
        IdTarea: any;
        Alarma: any;
        descripcion: any;
        ticketRedmine: any;
        Ci: any;
        Prioridad: any;
        Usuario: any;
        NombreContrato: any;
      }) => {
        const {
          Alarma,
          Prioridad,
          descripcion,
          ticketRedmine,
          Ci,
          Usuario,
          NombreContrato,
        } = caso;

        const partesResumen = [];
        if (Prioridad) {
          if (Prioridad) {
            partesResumen.push(`Prioridad: ${Prioridad}`);
          }
        }
        if (Alarma) {
          partesResumen.push(`Titulo: ${Alarma}`);
        }
      if (descripcion) {
        const value = formatDescripcion(descripcion);
        partesResumen.push(`Descripción: ${value}`);
      }
        if (Ci) {
          partesResumen.push(`Ci: ${Ci}`);
        }
        if (Usuario) {
          partesResumen.push(`Asignado: ${Usuario}`);
        }
        if (NombreContrato) {
          partesResumen.push(`Contrato: ${NombreContrato}`);
        }

        const renderTicketRedmine = shouldRenderTicket(ticketRedmine);
        if (renderTicketRedmine) {
          partesResumen.push(`Ticket Redmine Nro: ${ticketRedmine}`);
        }
        const resumen =
          partesResumen.length > 0
            ? partesResumen.join("\n\n")
            : "No pudimos obtener los datos del caso";

        return { ...caso, resumen };
      },
    ),
  );

  return newLocal;
};

/**
 * Custom Hook que recibe un array de casos y devuelve una versión
 * memorizada y formateada con la propiedad 'resumen' añadida.
 * @param {Array<object>} casosOriginales - El array original de casos (ej: response.data.Data).
 * @returns {Array<object>} - El array de casos formateados.
 */
export const useCasosFormateados = (casosOriginales: any, perfil?: number) => {
  let listaFormateada: any;
  if (!Array.isArray(casosOriginales)) {
    return listaFormateada;
  }
  return generarResumenParaCaso(casosOriginales, perfil);
};
